"use client";

import { Wrench } from "lucide-react";

export function MaintenancePage({
  message,
  endsAt,
}: {
  message: string;
  endsAt: string | null;
}) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 px-4 text-center">
      <Wrench className="mb-6 h-16 w-16 text-gray-400" />
      <h1 className="mb-3 text-2xl font-semibold text-gray-900">
        Under Maintenance
      </h1>
      <p className="mb-6 max-w-md text-gray-600">{message}</p>
      {endsAt && (
        <p className="text-sm text-gray-500">
          Expected to be back by{" "}
          <time dateTime={endsAt}>
            {new Date(endsAt).toLocaleTimeString([], {
              hour: "numeric",
              minute: "2-digit",
              timeZoneName: "short",
            })}
          </time>
        </p>
      )}
    </div>
  );
}
